import React, { Component } from "react";
import "./print.scss";

class CallToActionFooter extends Component {
  render() {
    const { isMemberOfTeam } = this.props.agentData;
    if (isMemberOfTeam) {
      return (
        <div className="print-call-to-action-footer">
          <p>
            Contact us to Today to Discover your Home's Value in Today's Market
          </p>
        </div>
      );
    } else {
      return (
        <div className="print-call-to-action-footer">
          <p>
            Contact me to Today to Discover your Home's Value in Today's Market
          </p>
        </div>
      );
    }
  }
}

export default CallToActionFooter;
